import { render, staticRenderFns } from "./UniLevelBonusHistory.vue?vue&type=template&id=1fe00fa2&"
import script from "./UniLevelBonusHistory.vue?vue&type=script&lang=js&"
export * from "./UniLevelBonusHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports